import { Checkbox } from 'app/ui/form/index';
import { withLabel } from 'app/ui/form/utils';

export default withLabel(Checkbox);
